<template>
  <div class="image-column">
    <el-carousel :autoplay="false" :height="showPicture.height + 'px'" :arrow="showArrow">
      <el-carousel-item v-for="item in pictureList" :key="item.src">
        <el-image
          class="image-column-image"
          @click.native="previewPicture(item)"
          :style="{width: `${showPicture.width}px`, height: `${showPicture.height}px`}"
          :src="item.src.includes('http')?item.src:ossDownloadUrl + item.src"
          fit="fill"></el-image>
      </el-carousel-item>
    </el-carousel>
    <PicturePreview ref="picturePreview" @closePreview="closePreview" :coverPicList="pictureList" v-if="swiperFlag" :src="previewImgaeSrc"></PicturePreview>
  </div>
</template>

<script>
import PicturePreview from '@/components/form/runtime/components/picture-preview-swiper.vue'
export default {
  name: 'image-column',
  props: {
    data: [String, Number],
    showPicture: Object
  },
  components: {
    PicturePreview
  },
  data () {
    let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl') || ''
    return {
      swiperFlag: false,
      ossDownloadUrl: ossDownloadUrl,
      previewImgaeSrc: ''
    }
  },
  computed: {
    pictureList () {
      return this.formatPicData(this.data)
    },
    showArrow () {
      if (this.pictureList.length <= 1) {
        return 'never'
      } else {
        return 'always'
      }
    }
  },
  methods: {
    formatPicData (data) {
      let array = []
      let pictureType = ['png', 'jpg', 'jpeg', 'gif']
      if (data) {
        data.split('$.$').forEach(m => {
          if (m && m.lastIndexOf('.') && pictureType.includes(m.slice(m.lastIndexOf('.') + 1).toLocaleLowerCase())) {
            array.push({'name': m.split(',/')[0], 'src': m.slice(m.indexOf(',/') + 1), 'url': m.slice(m.indexOf(',/') + 1)})
          }
        })
      }
      return array
    },
    previewPicture (img) {
      this.previewImgaeSrc = img.src
      this.$nextTick(() => {
        this.swiperFlag = true
      })
    },
    closePreview () {
      this.swiperFlag = false
    }
  }
}
</script>
<style lang="scss">
  .image-column{
    .el-carousel {
      .el-carousel__container{
        .el-carousel__arrow{
          background-color: transparent;
          .el-icon-arrow-left,.el-icon-arrow-right{
            font-size: 16px;
            color: #CCCDCE;
            &:hover{
              color: #55ACF1;
            }
          }
          &:hover{
            background-color: transparent;
          }
        }
      }
      .el-carousel__indicators{
        .el-carousel__indicator{
          display: none;
        }
      }
    }
    .image-column-image{
      cursor: pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/report/runtime/tableComponents/image-column.vue